<template>
  <!-- Export All, Export visible|filtered-->
  <!--
  @usage
<template>
  <export
    :filters="filters"
    :url="exportUrl"
    :limit="usersList.length">
    Export
  </export>
</template>

<script>
import Export from '@/vue/common/export'
...
export default {
  ...
  components: {
    ...
    Export
  },
  data () {
    return {
      ...
      exportUrl: URL-TO-ENDPOINT,
      usersList: [],
      filters: {...}
    }
  }
}

</script>
  -->
  <div>
    <div>
      <a-dropdown>
        <a
          class="ant-dropdown-link"
          @click="e => e.preventDefault()">
          <slot /> <i class="padded mdi mdi-calendar-export" />
        </a>
        <a-menu slot="overlay">
          <template v-for="(item,index) in modes">
            <a-menu-item
              :key="`export-${index}-${item.id}`"
              :disabled="loading"
              @click="() => onExport(item)">
              {{ item.label }}
            </a-menu-item>
          </template>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
import { clearObject } from '@/js/helpers/clear-object'
import ADropdown from 'ant-design-vue/lib/dropdown'
import AMenu from 'ant-design-vue/lib/menu'

export default {
  name: 'export',
  components: {
    'a-dropdown': ADropdown,
    'a-menu': AMenu,
    'a-menu-item': AMenu.Item,
  },
  props: {
    filters: {
      type: Object,
      default: () => {},
    },
    limit: {
      type: Number,
      default: 15,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    onGetDownloadUrl: {
      type: Function,
      required: true,
    },
  },
  data () {
    return {
      defaultLimit: 10000,
      modes: [
        { id: 'all', label: 'All' },
        { id: 'visible', label: 'Visible' },
      ],
      mode: '', // all|visible
    }
  },
  methods: {
    async onExport (item) {
      let query = {}

      this.mode = item.id

      switch (this.mode) {
        case this.modes[1].id: // visible
          const filters = clearObject({
            user_id: this.filters.id,
            email_search: this.filters.email,
            role: this.filters.role,
            address_search: this.filters.eth_address,
            name_search: this.filters.name,
          })

          Object.keys(filters).forEach(key => {
            query[`filter[${key}]`] = filters[key]
          })

          query['page[limit]'] = this.limit

          break
        default:
          query['page[limit]'] = this.defaultLimit
          break
      }
      const url = await this.onGetDownloadUrl(query)

      this.mode = ''

      window.open(url, '_blank')
    },
  },
}
</script>

<style scoped>
  @import '~ant-design-vue/lib/dropdown/style/index.css';

  .padded {
    padding-left: 0.1em;
  }

  .ant-dropdown-link {
    cursor: pointer;
  }
</style>
